var get$ = (function() {
  var connections = {};

  return function(id, def) {
    return (connections[id] = connections[id] || def || {});
  };
})();

angular.module('bbl.services.simpleshare')

.directive('simpleshareBtn', ['sharer', '$parse', function(sharer, $parse) {
  var scr = {canShare: false};
  sharer.canShare().then(function(){
    scr.canShare = true;
  });

  return {
    restrict: 'EA',
    transclude: true,
    template: '<div class="share-screen-btn" ng-click="shareScreen()"><span ng-transclude></span></div>',
    link: function($scope, $el, atts) {
      var user = $parse(atts.user).bind(0, $scope),
        room = $parse(atts.room)($scope);

      $scope.scr = scr;

      angular.extend($scope.conn, get$(room, {active: null}));

      $scope.$parent.isSharing = function() {
      	return $scope.conn.active && $scope.conn.active.getLocalStreams().length;
      };

      // share screen click handler
      $scope.shareScreen = function() {
      	if($scope.isSharing()) {
          return sharer.stopSharing(null, null, $scope.conn.active);
      	}

        // init a share screen session for current room
        sharer.share(room, user()).then(function(conn) {
          // screenshare session started, save the active connection
          $scope.conn.active = conn;

          var removeStream = function(stream) {
            conn.removeStream(stream);
            $scope.conn.stream = conn.getLocalStreams().filter(function(s) { return s.active; })[0];

            $scope.$apply();
          };

          var stream = conn.getLocalStreams().filter(function(s) { return s.active; })[0];
          stream.addEventListener('inactive', removeStream.bind(0, stream));
          stream.addEventListener('removetrack', removeStream.bind(0, stream));

          $scope.conn.stream = stream;
        });
      };
    }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/directives/share-btn.js
 ** module id = 222
 ** module chunks = 0
 **/